import { render } from "./SalesAssistantMode.vue?vue&type=template&id=55f98553&scoped=true"
import script from "./SalesAssistantMode.vue?vue&type=script&lang=js"
export * from "./SalesAssistantMode.vue?vue&type=script&lang=js"

import "./SalesAssistantMode.vue?vue&type=style&index=0&id=55f98553&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f98553"]])

export default __exports__